module.exports = __webpack_public_path__ + "e02fd668b91bb29fd30cb0939fc42bbe.otf";